import {useEffect, useState} from "react";
import Modal, {ModalBody, ModalHeader} from "../../../Components/Modal";
import "./Dashboard.scss";
import axios from "axios";
import Loader from "../../../Components/Loader";
import DefaultDashboard from "./DefaultDashboard";
import DashboardType1 from "./DashboardType1";
import DashboardType2 from "./DashboardType2";
import DashboardType3 from "./DashboardType3";
import useTitle from "../../../Components/Hooks/useTitle";
import DashboardType4 from "./DashboardType4";
import DashboardTypeSaden from "./DashboardTypeSaden";
import _axios from "../../../httpService";
import {prefixUrl} from "../../../utils/utilsData";
import Swal from 'sweetalert2';
import DashboardTypeSCL from "./DashboardTypeSCL";
import DashboardType8 from "./DashboardType8";
import DashboardType9 from "./DashboardType9";
import DashboardType10Noyara from "./DashboardType10Noyara";
import DashboardType11Arka from "./DashboardType11Arka/DashboardType11Arka";
import DashboardType12Chika from "./DashboardType12Chika/DashboardType12Chika";

export default function Dashboard(props) {
  useTitle("داشبورد");

  let widgetArray = [
    {
      element: {
        type: "icon",
        value: "fa fa-pencil",
      },
      title: "Edited Docs",
      text: "250",
    },

    {
      element: {
        type: "icon",
        value: "fa fa-trash",
      },
      title: "Trash Docs",
      text: "160",
    },
  ];
  const [showPhaseOptions, setShowPhaseOptions] = useState(false);
  const [showAdminReport, setShowAdminReport] = useState(false);
  const [firstPageTable, setFirstPageTable] = useState("");
  const [showLoader, setShowLoader] = useState(true);
  const [firstPageHtml, setFirstPageHtml] = useState("");

  const [dashboardComponentData, setDashboardComponentData] = useState({});
  const [whichType, setWhichType] = useState("type0");

  function setDateFu() {
    Date.today().add(-30).days(); // or...
    Date.today().add({days: -30});
  }

  const [updateData, setUpdateData] = useState(true);
  const [refreshData, setRefreshData] = useState(false);

  useEffect(() => {
    axios({
      method: "GET",
      url: `${localStorage.getItem("apiUrl")}/lastUpdate/`,

      headers: {Authorization: `Bearer ${localStorage.getItem("token")}`},
    }).then((response) => {
      setVersionModalIsOpen(response.data.lastUpdate);
      setNewVersion(response.data);
      // setShowAdminReport(response.data.manager)
      localStorage.setItem("isAdmin", response.data.manager);

      setShowPhaseOptions(response.data.showPhaseOptions);
      setFirstPageTable(response.data.firstPageTable);
      // اینو میزارم توی لوکال استوریج بعدا لازم میشه
      localStorage.setItem("dashboardType", response.data.dashboardType);
      // localStorage.setItem("dashboardType", "2");
      // چون هنوز از کانکتکس به خوبی استفاده نکردم فعلا جواب اومد میزارم توی لوکال استوریج و توی  هدر میرم از توی لوکال استوریج میخونم
      response.data.KMO && localStorage.setItem("userName", response.data.KMO);
    });

    // قرار شد بعد از این ب بعد مهندس طاهری بگه آیا داشبورد استانداری که توی فرانت هست رو نشو ن
    // بدیم یا  از بک اند  اطلاعات رو نشون بدم
    _axios
      .get(prefixUrl() + "/firstPageDashboard/")
      .then((res) => {
        setWhichType(res.data.type);
        setShowAdminReport(res.data.manager);
        // setWhichType("type12");
        setDashboardComponentData({...res.data.data});
        setShowLoader(false);
        let data = {...res.data.data};

        data.pictureUrl && localStorage.setItem("picture", data.pictureUrl);

        // در حالت اتوسی دارم دستی میگم تایپ باید 3 باشه

        // if (data.status) {
        //   const temp = data.firstPageHtml.replaceAll("\r\n", "")
        //   console.log(temp)
        //   setFirstPageHtml(temp)
        //   setShowLoader(false)
        // } else {
        //   setShowLoader(false);
        // }
      })
      .catch((error) => {
        setShowLoader(false);
        //alert(error);
        Swal.fire({
          title: "تایپ مشخص نشده",
          text: error,
          icon: 'error',
          showCancelButton: false,
          allowOutsideClick: true,
          showConfirmButton: true,
          confirmButtonText: 'بستن'
        })
        console.log(error);
        // setShowLoader(false);
      });
  }, [updateData, refreshData]);

  const [versionModalIsOpen, setVersionModalIsOpen] = useState(false);
  const [newVersion, setNewVersion] = useState("");

  function versionModalIsOpenCallbackHandler({isOpen}) {
    setVersionModalIsOpen(isOpen);
  }

  const [titleInDashboard, setTitleInDashboard] = useState(" در حال بارگزاری");

  try {
    return (
      <>
        <Modal
          isOpen={versionModalIsOpen}
          modalCallback={versionModalIsOpenCallbackHandler}
        >
          <ModalHeader/>
          <ModalBody>
          <span>
            نسخه{" "}
            {newVersion.lastUpdate !== undefined &&
              newVersion.lastUpdate.version}{" "}
            منتشر شد
          </span>
            <p>
              <i className="fas fa-circle"></i>
              {newVersion.lastUpdate !== undefined &&
                newVersion.lastUpdate.message}
            </p>
          </ModalBody>
        </Modal>
        <div
          className="dashboard"
          style={
            firstPageHtml !== "" ? {background: "#1B1B1B", color: "#fff"} : {}
          }
        >
          {showLoader ? (
            <div>
              <Loader text={"در حال بارگزاری اطلاعات داشبورد...."}/>
            </div>
          ) : whichType === "type0" ? (
            // firstPageHtml === "" ?
            <DefaultDashboard
              updateData={updateData}
              setUpdateData={setUpdateData}
              showPhaseOptions={showPhaseOptions}
              showAdminReport={showAdminReport}
              titleInDashboard={titleInDashboard}
              firstPageTable={firstPageTable}
              setTitleInDashboard={setTitleInDashboard}
              dashboardComponentData={dashboardComponentData}
            />
          ) : whichType === "type1" ? (
            <DashboardType1 dashboardComponentData={dashboardComponentData}/>
          ) : whichType === "type2" ? (
            <DashboardType2 dashboardComponentData={dashboardComponentData}/>
          ) : whichType === "type3" ? (
            <DashboardType3 dashboardComponentData={dashboardComponentData}/>
          ) : whichType === "type4" ? (
            <DashboardType4
              dashboardComponentData={dashboardComponentData}
              refreshData={refreshData}
              setRefreshData={setRefreshData}
            />
          ) : whichType === "type5" ? (
            <DashboardTypeSaden
              showAdminReport={showAdminReport}
              dashboardComponentData={dashboardComponentData}
            />
          ) : whichType === "type6" ? (
            <DashboardTypeSCL dashboardComponentData={dashboardComponentData}/>
          ) : whichType === "type7" ? (
            <DashboardType3 dashboardComponentData={dashboardComponentData}/>
          ) : whichType === "type8" ? (
            <DashboardType8 dashboardComponentData={dashboardComponentData}/>
          ) : whichType === "type9" ? (
            <DashboardType9 dashboardComponentData={dashboardComponentData}/>
          ) : whichType === "type10" ? (
            <DashboardType10Noyara dashboardComponentData={dashboardComponentData}/>
          ) : whichType === "type11" ? (
            <DashboardType11Arka dashboardComponentData={dashboardComponentData}
                                 refreshData={refreshData}
                                 setRefreshData={setRefreshData}/>
          ) :  whichType === "type12" ? (
            <DashboardType12Chika dashboardComponentData={dashboardComponentData}/>
          ) : (
            <>تایپ مشخص نشده است</>
          )}
        </div>
      </>
    );
  } catch (error) {
    return <>{error.toString()}</>
  }
}
